
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'academy-achievements-public-ui',
  currentProjectVersion: 'static-1.279',
  depVersions: {
  "academy-achievements-public-ui": "static-1.279",
  "apollo-dlb": "static-3.86",
  "client-types": "static-1.490",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8241",
  "hubspot-dlb": "static-2.1877",
  "react-dlb": "static-1.84",
  "academy-common-lib": "static-1.14714",
  "academy-navigation-lib": "static-1.2239",
  "analytics_js": "static-1.4412",
  "apollo-stack-hubspot": "static-3.84",
  "avatar-components": "static-1.2714",
  "classnames": "static-2.10",
  "data-fetching-client": "static-1.9875",
  "enviro": "static-4.455",
  "foundations-assets": "static-1.5091",
  "foundations-components": "static-1.8340",
  "foundations-theming": "static-1.4668",
  "graphql": "static-1.85",
  "hub-http": "static-1.6431",
  "hubspot-url-utils": "static-1.4282",
  "HubStyleTokens": "static-2.11697",
  "I18n": "static-7.1652",
  "quartz": "static-1.7324",
  "quartz-config": "static-1.1102",
  "quartz-core": "static-1.6543",
  "quartz-routing": "static-1.754",
  "quartz-tracking": "static-1.703",
  "raven": "static-3.5925",
  "react": "static-7.190",
  "react-dom": "static-7.85",
  "react-rhumb": "static-1.16925",
  "rpc-client-utils": "static-1.4879",
  "signup-constants": "static-1.19443",
  "styled-components": "static-2.94",
  "trellis-ecosystem": "static-1.7518",
  "ui-addon-i18n": "static-1.11363",
  "UIComponents": "static-3.8643",
  "viral-links-lib": "static-1.7290",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven-hubspot": "static-1.6232",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.83",
  "metrics-js": "static-1.9849",
  "react-redux": "static-7.75",
  "redux": "static-4.16",
  "bend-plugin-trellis-migration": "static-1.3550",
  "moment": "static-3.26",
  "bend-plugin-quartz": "static-1.3601",
  "quartz-webpack": "static-1.3548",
  "bend-plugin-quartz-routing": "static-1.402",
  "HeadJS": "static-2.782",
  "framer-motion": "static-1.75",
  "hs-test-utils-bend-plugin": "static-1.3352",
  "msw": "static-1.39",
  "testing-library": "static-1.155",
  "webpack-env": "static-1.54",
  "academy-service-client": "static-1.3906",
  "ai-components-ui-library": "static-1.9526",
  "copilot-toolkit": "static-1.11692",
  "croppie": "static-2.10",
  "cssUtils": "static-1.857",
  "feedback-loader": "static-1.29693",
  "FileManagerCore": "static-1.39794",
  "FileManagerLib": "static-1.39935",
  "final-form": "static-1.73",
  "foundations-components-legacy": "static-1.1365",
  "foundations-theming-specialty": "static-1.2384",
  "hs-lodash": "static-4.45",
  "hs-story-utils": "static-1.9642",
  "HubStyle": "static-2.12004",
  "icons": "static-2.671",
  "immer": "static-1.94",
  "magpie-lib": "static-1.5702",
  "markdown-it": "static-1.6",
  "navigation-components": "static-1.18669",
  "navigation-messaging": "static-1.7996",
  "onboarding-tours": "static-1.17000",
  "PatternValidationJS": "static-1.3114",
  "quick-fetch": "static-1.4068",
  "react-utils": "static-2.5492",
  "SafeStorage": "static-1.4620",
  "sanitize-text": "static-1.8366",
  "sassPrefix": "static-1.161",
  "SharedI18nStrings": "static-1.182",
  "StyleGuideUI": "static-3.492",
  "ui-addon-react-router-dom": "static-1.9750",
  "ui-addon-video-player": "static-1.8922",
  "ui-fonts": "static-1.959",
  "ui-images": "static-2.1219",
  "usage-tracker-container": "static-1.7563",
  "usage-tracker-core": "static-1.7423",
  "video-embed": "static-1.36480",
  "wootric-nps": "static-1.7137",
  "zustand": "static-1.79",
  "storybook-react": "static-1.36",
  "hub-http-shared-msw-handlers": "static-1.10480",
  "hubspotter-http": "static-1.4800",
  "fast-json-stable-stringify": "static-1.4",
  "bend-plugin-foundations-components": "static-1.4609",
  "floating-ui": "static-1.60",
  "react-aria": "static-1.69",
  "react-create-root-preference": "static-1.52",
  "react-select-plus": "static-1.108",
  "react-virtualized": "static-2.103",
  "tanstack-table": "static-1.58",
  "trellis-assets": "static-1.2387",
  "bend-plugin-foundations-theming": "static-1.3151",
  "foundations-theming-base": "static-1.3653",
  "stylex": "static-1.37",
  "hs-locale-management": "static-1.231",
  "i18n-data": "static-1.226",
  "moment-timezone": "static-5.86",
  "jasmine": "static-4.4536",
  "jasmine-runner": "static-1.6666",
  "dispatcher": "static-1.140",
  "general-store": "static-6.20",
  "hub-http-janus": "static-1.860",
  "mobile-manifest-mixins": "static-1.557",
  "module-federation": "static-1.29",
  "quartz-auth": "static-1.999",
  "quartz-head": "static-1.989",
  "quartz-i18n": "static-1.999",
  "quartz-test": "static-1.999",
  "trellis-components": "static-1.2406",
  "usage-tracker-session-replay": "static-1.5259",
  "csstype": "static-1.50",
  "web-vitals": "static-1.9",
  "bend-plugin-chirp-manifest": "static-1.289",
  "chirp-fetch": "static-1.2105",
  "marketplace-ui-apps-core": "static-1.19029",
  "marketplace-ui-common": "static-1.20497",
  "trellis-story-utils": "static-1.4726",
  "foundations-components-test-utils": "static-1.5823",
  "react-input-autosize": "static-2.17",
  "signup-ui-url-generator": "static-2.8274",
  "bender-build-tools": "static-1.3344",
  "ts-schema": "static-1.4228",
  "autolinker": "static-3.11",
  "chatspot-core": "static-1.22479",
  "ContentUtils": "static-1.69000",
  "customer-data-objects-ui-components": "static-1.13247",
  "sanitize": "static-1.4693",
  "breeze-engine-lib": "static-1.1507",
  "magpie-types": "static-1.5162",
  "simple-logging-lib": "static-1.3265",
  "breeze-artifacts-sdk": "static-1.96",
  "audio-components": "static-1.6236",
  "cropperjs": "static-1.10",
  "file-manager-components": "static-1.24295",
  "FileManagerImages": "static-1.37446",
  "html-to-image": "static-1.57",
  "immerable": "static-1.4367",
  "react-colorpicker": "static-2.10428",
  "react-immutable-proptypes": "static-2.8",
  "redux-toolkit": "static-1.7",
  "reselect": "static-3.8",
  "salesImages": "static-1.530",
  "ui-universal-auth": "static-1.9241",
  "urlinator": "static-1.4749",
  "usage-tracker": "static-1.7573",
  "video-components": "static-1.13990",
  "video-data-lib": "static-1.35646",
  "redux-thunk": "static-2.43",
  "idb-keyval": "static-1.47",
  "reactive-lib": "static-1.937",
  "nest": "static-1.454",
  "getting-started-shared-tasks": "static-1.19057",
  "growth-data-modal": "static-1.5779",
  "growth-onboarding-confetti": "static-1.3277",
  "growth-onboarding-next-action-utils": "static-1.2542",
  "onboarding-tours-client": "static-1.5214",
  "onboarding-tours-utils": "static-1.1066",
  "ui-shepherd-react": "static-3.10478",
  "ui-shepherd-tracker": "static-1.7859",
  "user-context": "static-1.5330",
  "transmute": "static-2.85",
  "outpost": "static-1.4380",
  "hubspotter-http-shared-msw-handlers": "static-1.10478",
  "base-ui": "static-1.17",
  "react-day-picker": "static-1.6",
  "trellis-theming": "static-1.1170",
  "tanstack-virtual": "static-1.35",
  "amplitude-session-replay-browser": "static-1.60",
  "developer-experience-shared-components": "static-1.10715",
  "immutable-less": "static-1.4867",
  "marketplace-ui-client-types": "static-1.17904",
  "ui-addon-iframeable": "static-1.9293",
  "ui-addon-integrations-directory-panel": "static-2.8241",
  "ui-extensibility-client-types": "static-1.4137",
  "ai-settings-ui-library": "static-1.8217",
  "integrations-lib": "static-1.16864",
  "laboratory-lib": "static-3.7368",
  "nav-meta": "static-1.30306",
  "react-window": "static-1.13",
  "superstore": "static-1.4973",
  "ui-addon-upgrades": "static-9.18286",
  "ui-product-approvals-common": "static-1.837",
  "cms-field-types": "static-1.5031",
  "content-icons-ui": "static-1.2292",
  "underscore": "static-1.8",
  "atom": "static-1.5292",
  "customer-data-objects": "static-1.7901",
  "customer-data-ui-utilities": "static-1.10043",
  "property-translator": "static-1.5612",
  "reference-resolvers": "static-1.8399",
  "breeze-engine-chat-components": "static-1.485",
  "breeze-engine-core": "static-1.785",
  "ably": "static-2.2",
  "highlight.js": "static-1.82",
  "content-assistance-lib": "static-1.8095",
  "apollo-link-hub-http": "static-2.4874",
  "video-components-external": "static-1.11988",
  "unified-auth-core-lib": "static-1.1037",
  "social-insights-client-types": "static-1.22638",
  "onboarding-data-sync-lib": "static-1.2349",
  "growth-onboarding-next-action-components": "static-1.2570",
  "user-context-client": "static-1.4754",
  "getting-started-shared-tasks-store": "static-1.18175",
  "apps-service-types": "static-1.3983",
  "inbound-db-meta-service-client": "static-1.3718",
  "oauth-service-types": "static-1.4471",
  "simple-data-table": "static-1.3391",
  "flux-actions": "static-1.356",
  "frontend-preferences-client": "static-1.8145",
  "hs-promise-utils": "static-1.5811",
  "hubspot-apollo-client": "static-1.5094",
  "integrations-error-boundary-lib": "static-1.14279",
  "integrations-tracking-lib": "static-1.5825",
  "native-integrations-shared-strings": "static-1.7994",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10582",
  "rxjs": "static-5.10",
  "unified-auth": "static-1.755",
  "merchandise-lib": "static-1.272",
  "purchase-motions-components": "static-1.6249",
  "inbound-db-properties-service-client": "static-1.3996",
  "react-dnd-compat": "static-1.4833",
  "react-immutable-render-mixin": "static-1.9",
  "ui-coaching-tips": "static-1.29162",
  "content-media-composition-data-lib": "static-1.13025",
  "content-media-compositions": "static-2.17032",
  "media-bridge-lib": "static-1.19297",
  "fsm": "static-1.3953",
  "InboxConnectUtils": "static-4.15404",
  "meetings-connect-utils-lib": "static-1.7824",
  "onboarding-scopes": "static-1.6675",
  "hubspot-apollo-cache": "static-1.553",
  "universal-page-editor-lib": "static-1.3228",
  "adobe-sign-auth-lib": "static-1.299",
  "ads-unified-auth-lib": "static-1.867",
  "google-sheets-integration-lib": "static-1.878",
  "microsoft-drive-integration-lib": "static-1.1006",
  "surveymonkey-integration-lib": "static-1.321",
  "slack-ui-library": "static-1.10615",
  "purchase-motions-api": "static-1.6252",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "growth-onboarding-feedback-components": "static-1.6799",
  "js-cookie": "static-1.18",
  "hub-http-contrib": "static-1.3256",
  "ui-addon-sales-email": "static-1.5429",
  "crm-record-cards-service-types": "static-1.3735",
  "framework-data-schema-resolvers": "static-1.7110",
  "location-customization-utils-lib": "static-1.9935",
  "seat-types-lib": "static-1.529",
  "batch-promise": "static-1.1761",
  "conditional-properties-service-client": "static-1.3947",
  "crm-pipelines-api-client-types": "static-1.4285",
  "fdsr-migration-layer": "static-1.229",
  "framework-builder-read-service-client": "static-1.4157",
  "framework-data-schema-quick-fetch": "static-1.7015",
  "multi-currency-client-types": "static-1.3841",
  "persist-promise": "static-1.3918"
},
  depPathPrefixes: {
  "academy-achievements-public-ui": "/academy-achievements-public-ui/static-1.279",
  "apollo-dlb": "/apollo-dlb/static-3.86",
  "client-types": "/client-types/static-1.490",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8241",
  "hubspot-dlb": "/hubspot-dlb/static-2.1877",
  "react-dlb": "/react-dlb/static-1.84",
  "academy-common-lib": "/academy-common-lib/static-1.14714",
  "academy-navigation-lib": "/academy-navigation-lib/static-1.2239",
  "analytics_js": "/analytics_js/static-1.4412",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.84",
  "avatar-components": "/avatar-components/static-1.2714",
  "classnames": "/classnames/static-2.10",
  "data-fetching-client": "/data-fetching-client/static-1.9875",
  "enviro": "/enviro/static-4.455",
  "foundations-assets": "/foundations-assets/static-1.5091",
  "foundations-components": "/foundations-components/static-1.8340",
  "foundations-theming": "/foundations-theming/static-1.4668",
  "graphql": "/graphql/static-1.85",
  "hub-http": "/hub-http/static-1.6431",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4282",
  "HubStyleTokens": "/HubStyleTokens/static-2.11697",
  "I18n": "/I18n/static-7.1652",
  "quartz": "/quartz/static-1.7324",
  "quartz-config": "/quartz-config/static-1.1102",
  "quartz-core": "/quartz-core/static-1.6543",
  "quartz-routing": "/quartz-routing/static-1.754",
  "quartz-tracking": "/quartz-tracking/static-1.703",
  "raven": "/raven/static-3.5925",
  "react": "/react/static-7.190",
  "react-dom": "/react-dom/static-7.85",
  "react-rhumb": "/react-rhumb/static-1.16925",
  "rpc-client-utils": "/rpc-client-utils/static-1.4879",
  "signup-constants": "/signup-constants/static-1.19443",
  "styled-components": "/styled-components/static-2.94",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7518",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11363",
  "UIComponents": "/UIComponents/static-3.8643",
  "viral-links-lib": "/viral-links-lib/static-1.7290",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.83",
  "metrics-js": "/metrics-js/static-1.9849",
  "react-redux": "/react-redux/static-7.75",
  "redux": "/redux/static-4.16",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3550",
  "moment": "/moment/static-3.26",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3601",
  "quartz-webpack": "/quartz-webpack/static-1.3548",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.402",
  "HeadJS": "/HeadJS/static-2.782",
  "framer-motion": "/framer-motion/static-1.75",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3352",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.155",
  "webpack-env": "/webpack-env/static-1.54",
  "academy-service-client": "/academy-service-client/static-1.3906",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.9526",
  "copilot-toolkit": "/copilot-toolkit/static-1.11692",
  "croppie": "/croppie/static-2.10",
  "cssUtils": "/cssUtils/static-1.857",
  "feedback-loader": "/feedback-loader/static-1.29693",
  "FileManagerCore": "/FileManagerCore/static-1.39794",
  "FileManagerLib": "/FileManagerLib/static-1.39935",
  "final-form": "/final-form/static-1.73",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1365",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2384",
  "hs-lodash": "/hs-lodash/static-4.45",
  "hs-story-utils": "/hs-story-utils/static-1.9642",
  "HubStyle": "/HubStyle/static-2.12004",
  "icons": "/icons/static-2.671",
  "immer": "/immer/static-1.94",
  "magpie-lib": "/magpie-lib/static-1.5702",
  "markdown-it": "/markdown-it/static-1.6",
  "navigation-components": "/navigation-components/static-1.18669",
  "navigation-messaging": "/navigation-messaging/static-1.7996",
  "onboarding-tours": "/onboarding-tours/static-1.17000",
  "PatternValidationJS": "/PatternValidationJS/static-1.3114",
  "quick-fetch": "/quick-fetch/static-1.4068",
  "react-utils": "/react-utils/static-2.5492",
  "SafeStorage": "/SafeStorage/static-1.4620",
  "sanitize-text": "/sanitize-text/static-1.8366",
  "sassPrefix": "/sassPrefix/static-1.161",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.182",
  "StyleGuideUI": "/StyleGuideUI/static-3.492",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9750",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8922",
  "ui-fonts": "/ui-fonts/static-1.959",
  "ui-images": "/ui-images/static-2.1219",
  "usage-tracker-container": "/usage-tracker-container/static-1.7563",
  "usage-tracker-core": "/usage-tracker-core/static-1.7423",
  "video-embed": "/video-embed/static-1.36480",
  "wootric-nps": "/wootric-nps/static-1.7137",
  "zustand": "/zustand/static-1.79",
  "storybook-react": "/storybook-react/static-1.36",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10480",
  "hubspotter-http": "/hubspotter-http/static-1.4800",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.4609",
  "floating-ui": "/floating-ui/static-1.60",
  "react-aria": "/react-aria/static-1.69",
  "react-create-root-preference": "/react-create-root-preference/static-1.52",
  "react-select-plus": "/react-select-plus/static-1.108",
  "react-virtualized": "/react-virtualized/static-2.103",
  "tanstack-table": "/tanstack-table/static-1.58",
  "trellis-assets": "/trellis-assets/static-1.2387",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3151",
  "foundations-theming-base": "/foundations-theming-base/static-1.3653",
  "stylex": "/stylex/static-1.37",
  "hs-locale-management": "/hs-locale-management/static-1.231",
  "i18n-data": "/i18n-data/static-1.226",
  "moment-timezone": "/moment-timezone/static-5.86",
  "jasmine": "/jasmine/static-4.4536",
  "jasmine-runner": "/jasmine-runner/static-1.6666",
  "dispatcher": "/dispatcher/static-1.140",
  "general-store": "/general-store/static-6.20",
  "hub-http-janus": "/hub-http-janus/static-1.860",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.557",
  "module-federation": "/module-federation/static-1.29",
  "quartz-auth": "/quartz-auth/static-1.999",
  "quartz-head": "/quartz-head/static-1.989",
  "quartz-i18n": "/quartz-i18n/static-1.999",
  "quartz-test": "/quartz-test/static-1.999",
  "trellis-components": "/trellis-components/static-1.2406",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5259",
  "csstype": "/csstype/static-1.50",
  "web-vitals": "/web-vitals/static-1.9",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.289",
  "chirp-fetch": "/chirp-fetch/static-1.2105",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.19029",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.20497",
  "trellis-story-utils": "/trellis-story-utils/static-1.4726",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5823",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8274",
  "bender-build-tools": "/bender-build-tools/static-1.3344",
  "ts-schema": "/ts-schema/static-1.4228",
  "autolinker": "/autolinker/static-3.11",
  "chatspot-core": "/chatspot-core/static-1.22479",
  "ContentUtils": "/ContentUtils/static-1.69000",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13247",
  "sanitize": "/sanitize/static-1.4693",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.1507",
  "magpie-types": "/magpie-types/static-1.5162",
  "simple-logging-lib": "/simple-logging-lib/static-1.3265",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.96",
  "audio-components": "/audio-components/static-1.6236",
  "cropperjs": "/cropperjs/static-1.10",
  "file-manager-components": "/file-manager-components/static-1.24295",
  "FileManagerImages": "/FileManagerImages/static-1.37446",
  "html-to-image": "/html-to-image/static-1.57",
  "immerable": "/immerable/static-1.4367",
  "react-colorpicker": "/react-colorpicker/static-2.10428",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "reselect": "/reselect/static-3.8",
  "salesImages": "/salesImages/static-1.530",
  "ui-universal-auth": "/ui-universal-auth/static-1.9241",
  "urlinator": "/urlinator/static-1.4749",
  "usage-tracker": "/usage-tracker/static-1.7573",
  "video-components": "/video-components/static-1.13990",
  "video-data-lib": "/video-data-lib/static-1.35646",
  "redux-thunk": "/redux-thunk/static-2.43",
  "idb-keyval": "/idb-keyval/static-1.47",
  "reactive-lib": "/reactive-lib/static-1.937",
  "nest": "/nest/static-1.454",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19057",
  "growth-data-modal": "/growth-data-modal/static-1.5779",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3277",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2542",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5214",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1066",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10478",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7859",
  "user-context": "/user-context/static-1.5330",
  "transmute": "/transmute/static-2.85",
  "outpost": "/outpost/static-1.4380",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10478",
  "base-ui": "/base-ui/static-1.17",
  "react-day-picker": "/react-day-picker/static-1.6",
  "trellis-theming": "/trellis-theming/static-1.1170",
  "tanstack-virtual": "/tanstack-virtual/static-1.35",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10715",
  "immutable-less": "/immutable-less/static-1.4867",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.17904",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9293",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8241",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.4137",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.8217",
  "integrations-lib": "/integrations-lib/static-1.16864",
  "laboratory-lib": "/laboratory-lib/static-3.7368",
  "nav-meta": "/nav-meta/static-1.30306",
  "react-window": "/react-window/static-1.13",
  "superstore": "/superstore/static-1.4973",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18286",
  "ui-product-approvals-common": "/ui-product-approvals-common/static-1.837",
  "cms-field-types": "/cms-field-types/static-1.5031",
  "content-icons-ui": "/content-icons-ui/static-1.2292",
  "underscore": "/underscore/static-1.8",
  "atom": "/atom/static-1.5292",
  "customer-data-objects": "/customer-data-objects/static-1.7901",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10043",
  "property-translator": "/property-translator/static-1.5612",
  "reference-resolvers": "/reference-resolvers/static-1.8399",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.485",
  "breeze-engine-core": "/breeze-engine-core/static-1.785",
  "ably": "/ably/static-2.2",
  "highlight.js": "/highlight.js/static-1.82",
  "content-assistance-lib": "/content-assistance-lib/static-1.8095",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4874",
  "video-components-external": "/video-components-external/static-1.11988",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1037",
  "social-insights-client-types": "/social-insights-client-types/static-1.22638",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2349",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2570",
  "user-context-client": "/user-context-client/static-1.4754",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18175",
  "apps-service-types": "/apps-service-types/static-1.3983",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3718",
  "oauth-service-types": "/oauth-service-types/static-1.4471",
  "simple-data-table": "/simple-data-table/static-1.3391",
  "flux-actions": "/flux-actions/static-1.356",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8145",
  "hs-promise-utils": "/hs-promise-utils/static-1.5811",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5094",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14279",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5825",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7994",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10582",
  "rxjs": "/rxjs/static-5.10",
  "unified-auth": "/unified-auth/static-1.755",
  "merchandise-lib": "/merchandise-lib/static-1.272",
  "purchase-motions-components": "/purchase-motions-components/static-1.6249",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3996",
  "react-dnd-compat": "/react-dnd-compat/static-1.4833",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29162",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13025",
  "content-media-compositions": "/content-media-compositions/static-2.17032",
  "media-bridge-lib": "/media-bridge-lib/static-1.19297",
  "fsm": "/fsm/static-1.3953",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15404",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.7824",
  "onboarding-scopes": "/onboarding-scopes/static-1.6675",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.553",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3228",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.299",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.867",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.878",
  "microsoft-drive-integration-lib": "/microsoft-drive-integration-lib/static-1.1006",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.321",
  "slack-ui-library": "/slack-ui-library/static-1.10615",
  "purchase-motions-api": "/purchase-motions-api/static-1.6252",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6799",
  "js-cookie": "/js-cookie/static-1.18",
  "hub-http-contrib": "/hub-http-contrib/static-1.3256",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5429",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3735",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7110",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.9935",
  "seat-types-lib": "/seat-types-lib/static-1.529",
  "batch-promise": "/batch-promise/static-1.1761",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3947",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4285",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.229",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4157",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7015",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3841",
  "persist-promise": "/persist-promise/static-1.3918"
}
};
